import { useState, useEffect } from "react";
import TestTrack from "test_track_js_client";
function ab(splitName, configuration) {
  void TestTrack.ab(splitName, configuration);
}
function vary(splitName, configuration) {
  void TestTrack.vary(splitName, configuration);
}
const useFeatureFlag = ({ splitName, context, trueVariant }) => {
  const [isEnabled, setIsEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    ab(splitName, {
      context,
      trueVariant,
      callback: (flagEnabled) => {
        setIsEnabled(flagEnabled);
        setIsLoading(false);
      }
    });
  }, [context, splitName, trueVariant]);
  return { enabled: isEnabled, loading: isLoading };
};
export {
  useFeatureFlag as u,
  vary as v
};
//# sourceMappingURL=useFeatureFlag-B-iuTFlU.js.map
